import { memo } from 'react'

import { FolderItem } from '@inno-sdks/files'
import { Button } from '@inno-ui/button'
import { FolderArrowDownLineIcon } from '@inno-ui/icons'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api'
import { usePermissions } from 'modules/desktop/modules/files-integration/hooks'
import { useDownloadAsZip } from 'modules/desktop/modules/files-integration/hooks/download/useDownloadAsZip'
import { sleep } from 'modules/desktop/modules/files-integration/utils'
import { useTranslation } from 'react-i18next'

import { useItemModal } from '../../hooks/useItemModal'
import styles from '../Preview.module.scss'

export const FolderPreview = memo(() => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop'
  })

  const { itemId, close } = useItemModal()

  const { data: item } = useGetFileItem<FolderItem>(itemId)
  const { canDownload } = usePermissions(item?.role)

  const downloadAsZip = useDownloadAsZip()

  return (
    <div className={styles.container}>
      <span>{t('preview-unavailable')}</span>
      {canDownload && (
        <Button
          label={t('download-as-zip')}
          icon={FolderArrowDownLineIcon}
          onClick={async () => {
            downloadAsZip([item!])
            await sleep(500)
            close()
          }}
        />
      )}
    </div>
  )
})
